import { Navigate, Outlet } from 'react-router-dom';

import { useAuthStore } from '@store/authStore';
import { LoadingSpinner } from '@components/ui/LoadingSpinner';
import { ROUTES } from '@constants/routes';

export const GuestRoute = () => {
  const { isAuthenticated, bootstrapped } = useAuthStore();

  if (!bootstrapped) return <LoadingSpinner fullScreen />;
  if (isAuthenticated) return <Navigate to={ROUTES.DASHBOARD} replace />;
  return <Outlet />;
};
